import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '90%',
    borderWidth: 1,
    borderColor: '#dbdbdb',
    borderRadius: 8,
    position: 'relative',
    marginBottom: 10
  },
  roomTitleContainer: {
    position: 'absolute',
    width: '100%',
    flexDirection: 'row',
    left: -16,
    top: -10
  },
  roomTitle: {
    paddingHorizontal: 10,
    paddingBottom: 1,
    borderBottomRightRadius: 20,
    display: 'flex',
    alignItems: 'center',
    top: -10,
    fontSize: 9,
    flexDirection: 'row'
  },
  roomTitleLabel: {
    color: 'black',
    marginLeft: 3,
    fontSize: 10
  },
  roomTitleValue: { fontSize: 10 },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'nowrap'
  },
  contentColumn1: {
    paddingHorizontal: 10,
    paddingLeft: 16,
    paddingVertical: 4,
    flex: 0.7,
    display: 'flex',
    flexDirection: 'column',
    borderRightWidth: 1,
    borderColor: '#dbdbdb',
    height: '100%'
  },
  contentColumn2: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    paddingRight: 0,
    flex: 0.7,
    display: 'flex',
    flexDirection: 'column'
  },
  contentColumn3: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderColor: '#dbdbdb'
  },
  contentColumn4: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    flex: 0.6,
    display: 'flex',
    flexDirection: 'column'
  },
  subject: {
    marginBottom: 4
  },
  subjectTitle: {
    fontSize: 8,
    color: 'black'
  },
  subtitle: { fontSize: 9, color: 'black', marginTop: 6, marginBottom: 6 },
  subjectValue: {
    marginTop: 3,
    fontSize: 7,
    color: 'black',
    fontWeight: 'bold'
  },
  subjectValuePrice: {
    marginTop: 3,
    fontSize: 8,
    color: 'black'
  }
})

export default styles
